<template>
  <div id="app">
    <main-header
      v-if="!$route.meta.hideHeader"
      @click.prevent.self
    />
    <div
      class="main-container"
      @click="closeAllFloatingBars()"
    >
      <main-menu
        v-if="!$route.meta.hideMenu"
        class="tall-menu"
      />
      <div
        class="router-component"
        :class="{
          login: $route.meta.hideMenu,
          valida: $route.name === 'Valida Alvaro Apoio' || $route.name === 'Valida Token'
        }"
      >
        <ResultsTrouble v-if="showOverdue" />
        <router-view v-else />
      </div>
    </div>
    <main-notifications v-if="!$route.meta.hideNotificationsBar && toggle.notification_view" />
    <preference-bar v-if="!$route.meta.hidePreferenceBar" />
    <feedback-modal />
    <toast-manager />
    <irregular-modal />
    <upload-xml-error-modal />
    <upload-xml-modal />
    <UploadFileErrorModal />
    <UploadFileModal />
    <stepper-modal v-if="!$route.meta.hideStepperBar" />
    <tour-guide v-if="!$route.meta.hideGuideTour && !toggle.covax" />
    <document-upload-modal v-if="!$route.meta.hideDocumentUploadModal" />
    <DashboardInfoModal
      ref="dashboardInfoModal"
      @modal-closed="closeModal()"
    />
  </div>
</template>

<script>
import MainHeader from './components/common/MainHeader'
import ToastManager from './components/common/toast/ToastManager'
import FeedbackModal from './components/common/feedback/FeedbackModal'
import IrregularModal from './components/common/irregular/IrregularModal'
import ComunicationBar from './components/Comunication/Sidebar/ComunicationBar'
import PreferenceBar from './components/common/PreferenceBar'
import TourGuide from './components/common/tour/TourGuide'
import UploadXmlModal from './components/UploadXml/UploadXmlModal'
import UploadXmlErrorModal from './components/UploadXml/UploadXmlErrorModal'
import UploadFileModal from './components/UploadFile/UploadFileModal'
import UploadFileErrorModal from './components/UploadFile/UploadFileErrorModal'
import StepperModal from './components/common/StepperModal'
import DocumentUploadModal from './components/Documents/Laboratory/Modal/Modal'
import DashboardInfoModal from '@/components/common/InfoModal'
import ResultsTrouble from '@/components/Results/ResultsTrouble'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    'main-header': MainHeader,
    'toast-manager': ToastManager,
    'feedback-modal': FeedbackModal,
    'irregular-modal': IrregularModal,
    'main-notifications': ComunicationBar,
    'tour-guide': TourGuide,
    'upload-xml-modal': UploadXmlModal,
    'upload-xml-error-modal': UploadXmlErrorModal,
    UploadFileModal,
    UploadFileErrorModal,
    'preference-bar': PreferenceBar,
    'stepper-modal': StepperModal,
    'document-upload-modal': DocumentUploadModal,
    DashboardInfoModal,
    ResultsTrouble
  },
  computed: {
    ...mapGetters(['profile', 'toggle', 'showOverdue', 'totalPendenciesQuantity']),
    ...mapGetters({ list: 'tutorialsList' })
  },
  watch: {
    list: {
      handler: function (newList) {
        if (newList.rastreabilityModal) this.openModal()
      },
      deep: true
    },
    totalPendenciesQuantity: {
      handler: function (data) {
        if (data > 0) {
          this.$refs.dashboardInfoModal.openPendencyAlertModal()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.setupInactivityListener()

    console.log('App mounted')
  },
  beforeDestroy() {
    this.removeInactivityListener()
  },
  methods: {
    ...mapActions([
      'setComunicationSidebarShowOff',
      'setPreferenceShowOff',
      'updateTutorialsList',
      'setupInactivityListener',
      'removeInactivityListener'
    ]),
    closeAllFloatingBars() {
      this.setComunicationSidebarShowOff(false)
      this.setPreferenceShowOff(false)
    },
    openModal() {
      this.$refs.dashboardInfoModal.openInfoModal()
    },
    closeModal() {
      this.updateTutorialsList({ tutorial: 'rastreabilityModal', action: false })
    }
  }
}
</script>

<style lang="scss">
  @import '../static/stylesheets/main';
  @import '../static/stylesheets/style-patterns';

  .main-container {
    display: flex;
    height: 100%;

    .router-component {
      width: 100%;
    }

    .login {
      width: 100%;
      padding-left: 0px;
    }
  }
</style>
